export default __webpack_public_path__ + "static/media/precios_LEED_feb_eng_sumeB.ba736aa3.png";